// extracted by mini-css-extract-plugin
export default {"input":"MessagesInput_input__zNeMA"};